import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LinearProgress } from '@material-ui/core';

const AnimatedProgress = ({ value, ...others }) => {
  const [completed, setCompleted] = useState(0);
  useEffect(() => {
    let timer;
    function increasingProgress() {
      if (completed < 0 || value < 0) {
        return;
      }

      setCompleted((oldCompleted) => {
        const diff = value / 5;
        return Math.min(oldCompleted + diff, value);
      });

      // catch negative values that would otherwise result in endless updates
      if (completed < value) {
        timer = setTimeout(increasingProgress, 100);
      }
    }

    timer = setTimeout(increasingProgress, 100);
    return () => {
      clearTimeout(timer);
    };
  }, [value, completed]);

  return (
    <LinearProgress
      {...others}
      value={Math.min(completed, 100)}
    />
  );
};

AnimatedProgress.propTypes = {
  value: PropTypes.number.isRequired,
};

export default AnimatedProgress;
